import { render, staticRenderFns } from "./persona-search-bar.vue?vue&type=template&id=39185844&scoped=true"
import script from "./persona-search-bar.vue?vue&type=script&lang=js"
export * from "./persona-search-bar.vue?vue&type=script&lang=js"
import style0 from "./persona-search-bar.vue?vue&type=style&index=0&id=39185844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39185844",
  null
  
)

export default component.exports